/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbMobileRefineMenuFilterCaratWeight_itemSearch$ref = any;
type SbMobileRefineMenuFilterCategory_itemSearch$ref = any;
type SbMobileRefineMenuFilterDeliveryOptions_itemSearch$ref = any;
type SbMobileRefineMenuFilterDimensions_itemSearch$ref = any;
type SbMobileRefineMenuFilterPrice_itemSearch$ref = any;
type SbMobileRefineMenuFilterStoneCut_itemSearch$ref = any;
type SbRespRefineMenuFilterCaratWeight_itemSearch$ref = any;
type SbRespRefineMenuFilterCategory_itemSearch$ref = any;
type SbRespRefineMenuFilterDeliveryOptions_itemSearch$ref = any;
type SbRespRefineMenuFilterDimensions_itemSearch$ref = any;
type SbRespRefineMenuFilterPrice_itemSearch$ref = any;
type SbRespRefineMenuFilterStoneCut_itemSearch$ref = any;
type SbSharedRefineMenuFilterAvailability_itemSearch$ref = any;
type SbSharedRefineMenuFilterColor_itemSearch$ref = any;
type SbSharedRefineMenuFilterCreator_itemSearch$ref = any;
type SbSharedRefineMenuFilterItemType_itemSearch$ref = any;
type SbSharedRefineMenuFilterMatchingSets_itemSearch$ref = any;
type SbSharedRefineMenuFilterMaterial_itemSearch$ref = any;
type SbSharedRefineMenuFilterMetal_itemSearch$ref = any;
type SbSharedRefineMenuFilterOrigin_itemSearch$ref = any;
type SbSharedRefineMenuFilterPeriod_itemSearch$ref = any;
type SbSharedRefineMenuFilterStone_itemSearch$ref = any;
type SbSharedRefineMenuFilterStyle_itemSearch$ref = any;
export type SbSharedRefineMenuFilters_itemSearch$ref = any;
export type SbSharedRefineMenuFilters_itemSearch = {
    readonly " $fragmentRefs": SbRespRefineMenuFilterPrice_itemSearch$ref & SbSharedRefineMenuFilterStone_itemSearch$ref & SbSharedRefineMenuFilterMetal_itemSearch$ref & SbSharedRefineMenuFilterColor_itemSearch$ref & SbMobileRefineMenuFilterPrice_itemSearch$ref & SbSharedRefineMenuFilterStyle_itemSearch$ref & SbSharedRefineMenuFilterOrigin_itemSearch$ref & SbSharedRefineMenuFilterPeriod_itemSearch$ref & SbRespRefineMenuFilterCategory_itemSearch$ref & SbRespRefineMenuFilterStoneCut_itemSearch$ref & SbSharedRefineMenuFilterCreator_itemSearch$ref & SbMobileRefineMenuFilterStoneCut_itemSearch$ref & SbMobileRefineMenuFilterCategory_itemSearch$ref & SbSharedRefineMenuFilterMaterial_itemSearch$ref & SbRespRefineMenuFilterDeliveryOptions_itemSearch$ref & SbMobileRefineMenuFilterDeliveryOptions_itemSearch$ref & SbSharedRefineMenuFilterItemType_itemSearch$ref & SbRespRefineMenuFilterDimensions_itemSearch$ref & SbRespRefineMenuFilterCaratWeight_itemSearch$ref & SbMobileRefineMenuFilterDimensions_itemSearch$ref & SbMobileRefineMenuFilterCaratWeight_itemSearch$ref & SbSharedRefineMenuFilterAvailability_itemSearch$ref & SbSharedRefineMenuFilterMatchingSets_itemSearch$ref;
    readonly " $refType": SbSharedRefineMenuFilters_itemSearch$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilters_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterPrice_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterStone_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterMetal_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterColor_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterPrice_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterStyle_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterOrigin_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterPeriod_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterCategory_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterStoneCut_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterCreator_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterStoneCut_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterCategory_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterMaterial_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterDeliveryOptions_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterDeliveryOptions_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterItemType_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterDimensions_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterCaratWeight_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterDimensions_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterCaratWeight_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterAvailability_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterMatchingSets_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = '5dff6816f3d3d2bcbed03d794b657337';
export default node;
